export default "__VITE_ASSET__DLCuWYbF__"